export default __webpack_public_path__ + "static/media/full_white.ad4e59ae.svg";